module.exports = __webpack_public_path__ + "static/bg-our-home-d41fcb8c738da132c7c23b936fb6ccf9.png";